<template>
    <div class="wheelContainer bg-white">
        <div class="shadowTop"></div>
        <div class="itemContainer">
            <img class="wheelRight" src="../assets/images/wheel-right.png">
            <img class="wheelLeft" src="../assets/images/wheel-left.png">
            <div v-if="isAnimating" class="wheelAnimation"></div>
            <div v-else class="spinningAni" :src="'images/'+imageDir+'/'+image">
                <img v-if="!checkVariation" class="productImage" :src="'images/'+imageDir+'/'+image">
                <img v-if="checkVariation" class="nameDecoration" src="../assets/images/name-decoration.png">
                <span class="productName">
                    <h2 v-if="checkVariation">{{productName}}</h2>
                </span>
            </div>
        </div>

        <div class="shadowBottom"></div>
    </div>
</template>

<script>

export default {
    name: "Wheel",
    components: {
    },
    data() {
        return {
            imageDir: "products"
        };
    },
    props: {
        image: {
            type: String,
            required: false
        },
        productName: {
            type: String,
            required: false
        },
        isAnimating: {
            type: Boolean,
            default: true
        },
        variation: {
            type: Number,
            default: 0
            // 0 = image, 1 text
        },
        threshold: {
            type: Number,
            default: 0
            // 0 = image, 1 text
        },
        nrQuestions: {
            type: Number,
            default: 0
            // 0 = image, 1 text
        },
        score: {
            type: Number,
            default: 0
            // 0 = image, 1 text
        },
        thresholdCounter: {
            type: Number,
            default: 0
            // 0 = image, 1 text
        },
        gameType: {
            type:String,
            required:true
        }
    },
    computed: {
        checkVariation() {
            if(this.gameType == "training") {
                return 0
            } else {
                return this.variation;
            }
        },
        maxScore() {
            return this.nrQuestions - this.threshold
        }
    },

    mounted() {}
};
</script>

<style scoped>
.wheelAnimation {
    background: url("../assets/images/wheel-blur.jpg") repeat-y;
    background-size: 100% auto;
    width: 100%;
    height: 100%;
    -webkit-animation: backgroundLoop 0.3s linear infinite;
    -moz-animation: backgroundLoop 0.3s linear infinite;
    animation: backgroundLoop 0.3s linear infinite;
}

@-webkit-keyframes backgroundLoop {
    from {
        background-position: 0 0;
    }
    to {
        background-position: 0 -100%;
    }
}

@keyframes backgroundLoop {
    from {
        background-position: 0 0;
    }
    to {
        background-position: 0 -100%;
    }
}

.shadowTop,
.shadowBottom {
    width: 100%;
    height: 35%;
    position: absolute;
    z-index: 4;
    background: red;
}
.shadowTop {
    top: 0;
    background: url("../assets/images/shadow-overlay.png");
    background-size: 100% 100%;
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
}
.shadowTop-bup {
}

.shadowBottom {
    bottom: 0;
    background: url("../assets/images/shadow-overlay.png");
    background-size: 100% 100%;
}
.shadowBottom-bup {
    bottom: 0;
    /* Permalink - use to edit and share this gradient: http://colorzilla.com/gradient-editor/#000000+0,000000+100&0+0,0.35+58,0.7+100 */
    background: -moz-linear-gradient(
        top,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.35) 58%,
        rgba(0, 0, 0, 0.7) 100%
    ); /* FF3.6-15 */
    background: -webkit-linear-gradient(
        top,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.35) 58%,
        rgba(0, 0, 0, 0.7) 100%
    ); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.35) 58%,
        rgba(0, 0, 0, 0.7) 100%
    ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#b3000000',GradientType=0 ); /* IE6-9 */
}
.wheelContainer {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0;
    overflow: hidden;
}
.wheel {
    margin: 0 auto;
    height: 100%;
    width: 100%;
}
.wheelLeft {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    height: 100%;
}
.wheelRight {
    position: absolute;
    z-index: 2;
    top: 0;
    right: 0;
    height: 100%;
}
.itemContainer {
    background:#FFF;
    height: 100%;
}
.productImage {
    display: inline;
    width:100%;
    margin-top: 10%;
}
.spinningAni {
    display: table;
    text-align: center;
    position: absolute;
    z-index: 1;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
}
.nameDecoration {
    text-align: center;
    position: absolute;
    z-index: 1;
    left: 10%;
    bottom: 10%;
    height: 80%;
    width: 80%;
}
.productName {
    display: table-cell;
    vertical-align: middle;
}
h1 {
    display:inline-block;
    max-width:60%;
}

h3 {
    margin: 4vh 4vw 5vh 4vw;
}
</style>
